module.exports = __webpack_public_path__ + "img/bancard-pago-seguro.f87bc0ad.svg";